import gql from 'graphql-tag'

export const customerContactFragment = gql`
    fragment customerContactFragment on CustomerContact{
        id
        deleted_at
        name
        title
        label
        street
        town
        state
        country
        zipcode
        primary_phone
        secondary_phone
        fax
        website
        email
        note
        customer_id
    }
`